//
//
//
//
//
//

export default {
  name: "container-item-wrapper",
  props: {
    widget: {
      type: Object,
      required: true
    }
  },
  computed: {
    customClass: function customClass() {
      return !!this.widget.options.customClass ? this.widget.options.customClass.join(' ') : '';
    }
  }
};